import ChallengeIpcRouter, {
  type ChallengeIpcRouterType,
  type ChallengeRunRequest,
} from '@shared/ipc/routers/ChallengeIpc.router'
import type { ChallengeResult } from '@shared/challenge/types'

class ChallengeIpcRenderer extends ChallengeIpcRouter implements ChallengeIpcRouterType {
  async getToken(request: ChallengeRunRequest): Promise<ChallengeResult> {
    return (await this.exec('getToken', request)) as ChallengeResult
  }

  async cancel(request: { runId: string }): Promise<void> {
    await this.exec('cancel', request)
  }
}

export default new ChallengeIpcRenderer()
